import { useEffect, useState } from "react";

export default function FlightProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const height = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(height > 0 ? Math.min(window.scrollY / height, 1) : 0);
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <div className="flight-track" id="flightTrack" aria-hidden="true">
      <div className="rail" />
      <div className="plane-marker" style={{ top: `calc(${progress * 100}% - ${progress * 26}px)` }}>
        <i className="fa-solid fa-location-arrow" />
      </div>
    </div>
  );
}
